import { render, staticRenderFns } from "./MinecraftStatus.vue?vue&type=template&id=73efb7b4&scoped=true"
import script from "./MinecraftStatus.vue?vue&type=script&lang=js"
export * from "./MinecraftStatus.vue?vue&type=script&lang=js"
import style0 from "./MinecraftStatus.vue?vue&type=style&index=0&id=73efb7b4&prod&scoped=true&lang=scss"
import style1 from "./MinecraftStatus.vue?vue&type=style&index=1&id=73efb7b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73efb7b4",
  null
  
)

export default component.exports